import { FC, useEffect, useRef } from "react";
import { Form, Input, Button, Upload } from "antd";
import { connect } from "react-redux";
import { fetchOneUser } from "../../../../redux/User/User.action";
import { ErrorHandler, getUserData, saveUserData } from "../../../../utilities/utilities";
import {
  removeData,
  sendUserOnlyData,
  sendUserSignature,
  UserComponentPropType,
} from "../../util/Setting.util";
import LoadingIndicator from "../../../common/Loading";
import { OpenNotification } from "../../../common/Notification/Notification.component";
import { Message, NotificationType } from "../../../../constants/Constants";
import { Telegram } from "@styled-icons/boxicons-logos";
import { UploadOutlined } from "@ant-design/icons";
import { fetchOneDocument } from "../../../../redux/Document/Document.action";
// import SignatureComponent from "../../../common/Signature/Signature.component";

const UserComponent: FC<UserComponentPropType> = ({
  fetchUser,
  user,
  form,
  setIsModalVisible,
  setLoading,
  loading,
  document,
  fetchDocument,
}) => {
  // const sigCanvas = useRef<any>({});

  useEffect(() => {
    fetchUser(getUserData().id);
    const docId = getUserData().document_id;
    if (docId) {
      fetchDocument(docId);
    }
  }, [fetchUser, fetchDocument]);

  useEffect(() => {
    if (user.payload?.document_id) {
      fetchDocument(user.payload.document_id);
    }
  }, [user.payload?.document_id, fetchDocument]);

  // const clear = () => sigCanvas.current.clear();

  const submit = (value: any) => {
    setLoading(true);
    var data = new FormData();

    const fileToUpload =
      value.file?.file instanceof File
        ? value.file.file
        : value.file?.file?.originFileObj ||
          value.file?.fileList?.[0]?.originFileObj ||
          (value.file instanceof File ? value.file : null);

    if (fileToUpload) {
      data.append("file", fileToUpload);
    }

    data.append("email", value.email);
    data.append("full_name", value.full_name);
    data.append("user_name", value.user_name || "");
    data.append("id", getUserData().id.toString());

    sendUserSignature(data)
      .then((res: any) => {
        const updatedDocId = res?.data?.data?.document_id;
        const currentData = getUserData();
        if (updatedDocId) {
          saveUserData({
            ...currentData,
            ...value,
            document_id: updatedDocId,
          });
          fetchDocument(updatedDocId);
        } else {
          saveUserData({
            ...currentData,
            ...value,
          });
        }
        fetchUser(getUserData().id);
        setLoading(false);
        setIsModalVisible(false);
        OpenNotification(
          NotificationType.SUCCESS,
          Message.USER_REGISTRATION_SUCCESS,
          ""
        );
      })
      .catch((error) => {
        setLoading(false);
        ErrorHandler(error).map((e: any) =>
          OpenNotification(
            NotificationType.ERROR,
            Message.USER_REGISTRATION_FAILED,
            e.message
          )
        );
      });
  };

  // const remove = () => {
  //   setLoading(true);
  //   removeData(user.payload.signature?.id)
  //     .then(() => {
  //       fetchUser(getUserData().id);

  //       setLoading(false);
  //       OpenNotification(
  //         NotificationType.SUCCESS,
  //         Message.SIGNATURE_REMOVE_SUCCESS,
  //         ""
  //       );
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       ErrorHandler(error).map((e: any) =>
  //         OpenNotification(
  //           NotificationType.ERROR,
  //           Message.SIGNATURE_REMOVE_FAILED,
  //           e.message
  //         )
  //       );
  //     });
  // };

  return user.isPending ? (
    <LoadingIndicator />
  ) : (
    <Form
      layout="vertical"
      onFinish={submit}
      initialValues={user.payload}
      form={form}
    >
      <div className="row">
        <div className="col-md-12">
          <Form.Item
            label="Name"
            rules={[{ message: "Please enter your full name", required: true }]}
            name="full_name"
          >
            <Input placeholder="name" />
          </Form.Item>
        </div>
        <div className="col-md-12">
          <Form.Item
            label="User Name"
            name="user_name"
          >
            <Input placeholder="username" />
          </Form.Item>
        </div>
        <div className="col-md-12">
          <Form.Item
            label="Email"
            rules={[
              { message: "Please enter new email address", required: true },
            ]}
            name="email"
          >
            <Input type="email" placeholder="Enter new email address" />
          </Form.Item>
        </div>
        <div className="col-md-12">
          <Form.Item
            label="Profile Image"
            name="file"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            style={{ textAlign: "left" }}
          >
            <Upload
              name="file"
              defaultFileList={[
                {
                  uid: "-1",
                  name: `${
                    document?.payload?.url ? document?.payload?.name : "No File"
                  }`,
                  status: "done",
                },
              ]}
              beforeUpload={(file) => {
                var reader: any = new FileReader();
                reader.readAsArrayBuffer(file);
                return false;
              }}
              type="select"
              multiple={false}
              maxCount={1}
              accept=".png,.jpg,.jpeg"
            >
              <Button className="btn-outline-secondary">
                <UploadOutlined /> Upload Profile Image
              </Button>
            </Upload>
          </Form.Item>
        </div>
        {`${user.payload.chat_id}`.startsWith("_") ? (
          <>
            <div className="col-md-6">
              <Form.Item label="Telegram Verification Key">
                <Input
                  placeholder="telegram id"
                  value={user.payload?.chat_id.split("_")[1]}
                  readOnly
                  onClick={() => {
                    navigator.clipboard.writeText(
                      `/verify_${user.payload?.chat_id.split("_")[1]}`
                    );
                    OpenNotification(
                      NotificationType.SUCCESS,
                      `Copied to clipboard`,
                      ""
                    );
                  }}
                />
              </Form.Item>
            </div>

            <div className="col-md-6 mt-3">
              <Button
                type="link"
                href="https://t.me/allura_notificationbot"
                target="_blank"
                icon={<Telegram size={25} />}
              >
                Verfiy account to get Notification
              </Button>
            </div>
          </>
        ) : null}
        {/* 
        {user.payload.signature ? (
          <>
            <div className="col-md-6 mt-3">
              <Form.Item label="Signature">
                <SignatureComponent user={user.payload} />
              </Form.Item>
            </div>
            <div className="col-md-6 mt-3">
              <Button loading={loading} onClick={remove} danger>
                Remove
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className="col-md-12">
              <Form.Item
                label="Signature"
                rules={[{ required: true, message: "Please input File" }]}
                name="file"
              >
                <Upload
                  name="file"
                  beforeUpload={(file) => {
                    return false;
                  }}
                  type="select"
                  multiple={false}
                  maxCount={1}
                >
                  <Button style={{ width: "100%" }}>
                    <UploadOutlined /> Click to Upload
                  </Button>
                </Upload>
              </Form.Item>
            </div>
            <div className="col">
              <Button
                className="btn btn-primary signature-clear"
                onClick={clear}
              >
                Clear
              </Button>
            </div>
          </>
        )} */}
      </div>
    </Form>
  );
};

/**
 * Map State to Props
 *
 * @param state
 */
const mapStateToProps = (state: any) => ({
  user: state.user.fetchOne,
  document: state.document.fetchOne,
});

/**
 * Map Dispatch to Props
 *
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: any) => ({
  fetchUser: (action: any) => dispatch(fetchOneUser(action)),
  fetchDocument: (action: any) => dispatch(fetchOneDocument(action)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserComponent);
